/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Custom serializer to properly pass GeoJSON types to frontend.
 * @export
 * @interface GeoJSONFeature
 */
export interface GeoJSONFeature {
    /**
     * 
     * @type {string}
     * @memberof GeoJSONFeature
     */
    type?: string;
    /**
     * 
     * @type {any}
     * @memberof GeoJSONFeature
     */
    geometry: any | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GeoJSONFeature
     */
    properties: { [key: string]: any; };
}

/**
 * Check if a given object implements the GeoJSONFeature interface.
 */
export function instanceOfGeoJSONFeature(value: object): value is GeoJSONFeature {
    if (!('geometry' in value) || value['geometry'] === undefined) return false;
    if (!('properties' in value) || value['properties'] === undefined) return false;
    return true;
}

export function GeoJSONFeatureFromJSON(json: any): GeoJSONFeature {
    return GeoJSONFeatureFromJSONTyped(json, false);
}

export function GeoJSONFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoJSONFeature {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'geometry': json['geometry'],
        'properties': json['properties'],
    };
}

export function GeoJSONFeatureToJSON(json: any): GeoJSONFeature {
    return GeoJSONFeatureToJSONTyped(json, false);
}

export function GeoJSONFeatureToJSONTyped(value?: GeoJSONFeature | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'geometry': value['geometry'],
        'properties': value['properties'],
    };
}

